$(function() {
  $('.js-tab-click li').on('click', function(){
    $('.js-tab-click li a').removeClass('is_active');
    $(this).find('a').addClass('is_active');
    var index = $(this).index();
    $('.js-tab-body > li').removeClass('is_active');
    $('.js-tab-body > li').eq(index).addClass('is_active');
  });
});
